import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign } from "../../../Constants/utils";
import { getAvgItemSale } from "../../../Redux/features/Dashboard/Charts/avgItemSaleChartSlice";
import { priceFormate } from "../../../hooks/priceFormate";
import { CommonChart } from "./CommonChart";

export const AvgItemSaleChart = ({
  merchantId,
  activeType,
  presentDate,
  avgItemSaleChartInView,
  avgItemSaleChartRef,
  selectedOutletIds = [],
}) => {
  const avgItemSaleChart = useSelector((state) => state.avgItemSaleChart);
  const chartKey = "avgItemSaleChart";

  return (
    <>
      <CommonChart
        componentRef={avgItemSaleChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getAvgItemSale}
        yAxisText={"Items per Transaction"}
        reduxState={avgItemSaleChart}
        reduxStateKey={"avgItemSaleData"}
        reduxStateTotalKey={"totalAvgItemSale"}
        valueKey={"total_revenue"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={avgItemSaleChartInView}
        title={"Items per Transaction"}
        totalValueFunction={priceFormate}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
